import {Component, HostListener, OnInit} from '@angular/core';
import {debounceTime, Observable, Subject, throwError} from "rxjs";
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {Router} from "@angular/router";

export interface ResultObj{
  barcode: string;
  generatedBarcode: string;
  name: string;
  clientPrice: string;
  image: string;
}
@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {

  resultList: ResultObj[]=[];
  menuOpen: boolean= false;
  searchTerms = new Subject<string>();
  searchProductList: any={};

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }
  constructor(private http: HttpClient, private apiKey:ApiUrl, private router:Router) { }

  ngOnInit(): void {
    this.initSearchInput();
  }

  onChange($event: KeyboardEvent) {
    
  }

  private initSearchInput(): void {
    this.searchProductList ={}
    this.searchTerms.pipe(debounceTime(250))
        .subscribe(term => {
          this.resultList =[]
          this.inProgress = true;
          this.browserSearch(term).subscribe(res=>{
            this.resultList = res.product.map(rs=>{return {id:rs.id, generatedBarcode: rs.generatedBarcode, barCode: rs.barCode, name: rs.name, clientPrice:rs.clientPrice, image: rs.images[0].small}});
            this.inProgress = false;
          })
          console.log(this.resultList)
        });
  }

  private handleObserverError(error: any): Observable<any>{
    return throwError(error.error || error)
  }

  browserSearch(query: string): Observable<any>{
    return this.http.get(this.apiKey.getBrowserSearch(query), this.options)
        .pipe(map((res) => res ? res: null),catchError(this.handleObserverError))
  }

  search($event: any): void {
    this.resultList = []
    if($event.target.value.length<3) return
    this.searchTerms.next($event.target.value);
  }

  openMenu() {
    this.menuOpen = true;
  }

  private wasInside = false;
  inProgress= false;
  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }
  @HostListener('document:click')
  clickOutSide($event: any): void{
    if (!this.wasInside) {
      this.menuOpen = false;
    }
    this.wasInside = false;
  }

  onBlur($event: FocusEvent) {

  }

  openProduct(prd) {
    this.router.navigate(['/products', prd.id, prd.name.replaceAll(' ','-')]).then(()=>window.location.reload());
  }
}
